import { useState } from 'react';
import { Title } from 'components/Title';

import ConsentForm from './ConsentForm';
export default function ConsentPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="ConsentPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="Partner Consent" subTitle="Partner Consent for Live the partner shop on our market place."  titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div> <ConsentForm /></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
